export class DomainEvent extends CustomEvent {
    constructor(domainEventType) {
        super(domainEventType);
    }
}